"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const type_graphql_1 = require("type-graphql");
const typeorm_1 = require("typeorm");
const OsmosysBaseEntity_1 = require("../OsmosysBaseEntity");
const auth_1 = require("../auth");
const OsmosysResource_1 = require("./OsmosysResource");
const class_validator_1 = require("class-validator");
const IsSemVer_1 = require("../../validators/IsSemVer");
let OsmosysResourceVersion = class OsmosysResourceVersion extends OsmosysBaseEntity_1.OsmosysBaseEntity {
};
tslib_1.__decorate([
    type_graphql_1.Field(() => OsmosysResource_1.OsmosysResource),
    typeorm_1.OneToOne(() => OsmosysResource_1.OsmosysResource, resource => resource.versions),
    tslib_1.__metadata("design:type", Object)
], OsmosysResourceVersion.prototype, "resource", void 0);
tslib_1.__decorate([
    type_graphql_1.Field(() => auth_1.User),
    typeorm_1.ManyToOne(() => auth_1.User, {
        cascade: true,
    }),
    tslib_1.__metadata("design:type", Object)
], OsmosysResourceVersion.prototype, "creatingUser", void 0);
tslib_1.__decorate([
    type_graphql_1.Field(),
    typeorm_1.Column({
        default: '',
    }),
    tslib_1.__metadata("design:type", String)
], OsmosysResourceVersion.prototype, "notes", void 0);
tslib_1.__decorate([
    type_graphql_1.Field(),
    typeorm_1.Column(),
    class_validator_1.Validate(IsSemVer_1.IsSemVer),
    tslib_1.__metadata("design:type", String)
], OsmosysResourceVersion.prototype, "version", void 0);
OsmosysResourceVersion = tslib_1.__decorate([
    type_graphql_1.ObjectType(),
    typeorm_1.Entity()
], OsmosysResourceVersion);
exports.OsmosysResourceVersion = OsmosysResourceVersion;
//# sourceMappingURL=OsmosysResourceVersion.js.map